import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateTime } from 'luxon';

interface AuthorizationState {
  cloudKey: string;
  isAuthorized: boolean;
  logoutAt?: number;
}

const initialState: AuthorizationState = {
  cloudKey: '',
  isAuthorized: false,
  logoutAt: undefined
};

interface Keys {
  cloudKey: string,
}

export const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    
    setKeys: (state, action: PayloadAction<Keys>) => {
      state.cloudKey = action.payload.cloudKey;
    },
    setAuthorization: (state, action: PayloadAction<boolean>) => {
      state.isAuthorized = action.payload;
      if (action.payload) {
        state.logoutAt = DateTime.utc().plus({days: 14}).toSeconds();
      } else {
        state.logoutAt = undefined;
      }
    }
  }
});

export const { setKeys, setAuthorization } = authorizationSlice.actions;
export default authorizationSlice.reducer;
